import CardHeader from "../../../../antd/components/CardHeader";
import Loader from "../../../../Components/Shared/Loader";
import useLoading from "../../../../Hooks/useLoading";
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { EditNewsAPI, GetNewsAPI } from "../../../../API/NewsAPI";
import { IResponseProps } from "../../../../Interfaces/IResponseProps";
import { useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../../../../Contexts/AuthContext";
import { useContext, useEffect, useState } from "react";
import { NewsModel } from "../../../../Models/NewsModel";

interface FormSubmitProps {
    title: string;
    externLink: string;
}

const EditNews = () => {
    const { userEmail } = useContext(AuthContext);
    const { id } = useParams();
    const { loading, toggleLoading } = useLoading();
    const navigate = useNavigate();
    const [news, setNews] = useState<NewsModel>();

    const schema = yup.object().shape({
        title: yup.string().max(100, "Limite de caracteres excedido! Limite: 100 Caracteres").default(news?.title),
        externLink: yup.string().max(500, "Limite de caracteres excedido! Limite: 500 Caracteres").default(news?.externLink)
    });

    const { register, handleSubmit, formState: { errors } } = useForm<FormSubmitProps>({
        resolver: yupResolver(schema)
    });

    const getNews = async () => {
        try {
            toggleLoading(true);

            await GetNewsAPI(id ?? "").then((resp: IResponseProps) => {
                if (resp.statusCode == 200) {
                    setNews(resp.data);
                }
            }).finally(() => toggleLoading(false));
        } catch (error: any) {
            toast.error(error);
            toggleLoading(false);
        }
    }

    const Submit = async (data: FormSubmitProps) => {
        try {
            toggleLoading(true);

            await EditNewsAPI(id ?? "", (data.title != "" ? data.title : news?.title) ?? "", (data.externLink != "" ? data.externLink : news?.externLink) ?? "", userEmail).then((resp: IResponseProps) => {
                if (resp.statusCode == 200) {
                    toast.success("Notícia editada com sucesso!");
                    navigate("/managementMenu/news");
                }
            }).finally(() => toggleLoading(false));
        } catch (error: any) {
            toast.error(error);
            toggleLoading(false);
        }
    }

    useEffect(() => {
        if (id != "") {
            getNews();
        }
    }, [id]);

    return (
        <div className='card ml-2 mr-2 mt-4'>
            {loading && <Loader />}
            <CardHeader
                pageName={"Editar Notícia"}
                hasPageBefore={true}
                pageBeforeName={"Gestão de Notícias"}
                linkPageBefore={"/managementMenu/news"}
            />
            <div className='card-body mt-4'>
                <form onSubmit={handleSubmit(data => Submit(data))} autoComplete='false'>
                    <div className='d-flex align-items-start flex-column'>
                        <label className='required'>Título da Notícia: </label>
                        <input defaultValue={news?.title} className='form-control' {...register("title")} />
                        <p className='error-message'>{errors.title?.message}</p>
                    </div>
                    <div className='d-flex align-items-start flex-column'>
                        <label className='required'>Link da Notícia: </label>
                        <input defaultValue={news?.externLink} className='form-control' {...register("externLink")} />
                        <p className='error-message'>{errors.externLink?.message}</p>
                    </div>
                    <button type='submit' className='btn btn-primary w-100'>Editar Notícia</button>
                </form>
            </div>
        </div>
    )
}

export default EditNews;